import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';

export const TODO_LINKS = [
  {
    iconClass: SystemIcon.GeneralMoney,
    label: 'My transactions',
    href: '/registry/transactions',
    headerKey: 'TRANSACTIONS',
  },
  {
    iconClass: SystemIcon.GeneralHistory,
    label: 'Payment history',
    href: '/apimarketplace/payment-history',
    headerKey: 'PAYMENT_HISTORY',
  },
  {
    iconClass: SystemIcon.BusinessPublicAccountingFirm,
    label: 'My corporate service provider (CSP)',
    href: '/registry/maintenance-of-csp-client-list/my-csp',
    headerKey: 'CORPORATE_SERVICE_PROVIDER',
  },
  {
    iconClass: SystemIcon.BusinessLimitedPartnership,
    label: 'My clients',
    href: '/registry/maintenance-of-csp-client-list/my-client',
    headerKey: 'MY_CLIENTS',
  },
];

export const todoStaticDateText =
  'Action items created from 02 Dec 2024 onwards will be displayed here.';
